import deepmerge from 'deepmerge';
import { loggerConfigurationSchema } from '../loggerConfigurationSchema';
const LOCAL_STORAGE_KEY = 'ori-logger-configuration';
export const LoggerBrowserConfiguration = {
  get() {
    const localStorageValue = window.localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!localStorageValue) {
      return null;
    }
    try {
      const parsed = loggerConfigurationSchema.partial().safeParse(JSON.parse(localStorageValue));
      return parsed.data ?? null;
    } catch {
      return null;
    }
  },
  set(input) {
    const validated = loggerConfigurationSchema.parse(input);
    window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(validated));
  },
  update(input) {
    const validated = loggerConfigurationSchema.partial().parse(input);
    const current = this.get();
    const mergedWithCurrent = current ? deepmerge(current, validated) : validated;
    window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(mergedWithCurrent));
  }
};
//# sourceMappingURL=LoggerBrowserConfiguration.js.map